import React from 'react';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import Bg from '../Medias/Photos/photo-bg4.jpg';
import SectionTestimonial from '../Components/SectionTestimonial';


const Testimonial = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='Client Testimonials' detail={<span style={{ fontSize: '18px' }}></span>} bg={Bg} textSize={10} />
      <SectionTestimonial />
      {/* <section className='pt-5 pb-5'>
        <Container className='pt-5 pb-5'>
          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <div className='px-5'>
                  <div className='bg-img ratio-16x9' style={{ backgroundImage: `url(${Photo1})`, backgroundColor: 'white', backgroundSize: 'contain' }}></div>
                  </div>
                  <h3 className='text-center'>Nuttha Punjavorn</h3>
                  <h6 className='text-center font-header fw-bold mb-0'>SVP Contract & Permit Management</h6>
                  <p className='text-center tx-color-primary'>Super Energy Corporation Public Company Limited</p>
                  <p className='mt-4 px-4'>“PT and Associates have been an invaluable legal partner in our M&A journey. Their exceptional expertise in corporate and M&A law was critical to the successful submission of our M&A application to the Energy Regulatory Commission. From strategic guidance to meticulous preparation of the application and market analysis, their support enabled us to navigate a highly complex transaction with clarity and confidence. The team's deep understanding of sector-specific regulations, particularly within the energy industry, truly distinguishes them in this field. Their professionalism, responsiveness, and legal acumen make PT and Associates a trusted advisor for any company pursuing mergers and acquisitions in regulated sectors.”</p>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body>
                  <div className='px-5'>
                  <div className='bg-img ratio-16x9' style={{ backgroundImage: `url(${Photo2})`, backgroundColor: 'white', backgroundSize: 'contain' }}></div>
                  </div>
                  <h3 className='text-center'>Pete Peerakarn Manakit</h3>
                  <h6 className='text-center font-header fw-bold mb-0'>Chief Executive Officer</h6>
                  <p className='text-center tx-color-primary'>ION Energy</p>
                  <p className='mt-4 px-4'>“PT and Associates have been instrumental in navigating the complex legal landscape of the energy sector. Their expertise in regulatory compliance, power purchase agreements, and direct power purchase structures has been invaluable in advancing our renewable energy projects. The team is meticulous in their legal analysis, and forward-thinking in their strategic counsel. Their professionalism and depth of knowledge make them an outstanding partner for any company seeking top-tier legal support in the energy sector.”</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section> */}
    </>
  )
}

export default Testimonial